import React from "react";
import { connect } from "react-redux";
import ReactEcharts from "echarts-for-react";
import {costPriceChartOption} from "../../Data/Charts";
import "echarts-gl";
class CostPriceDataChart extends React.Component {
  componentDidMount() {

  }
  componentDidUpdate(prevProps:Readonly<P>, prevState:Readonly<S>, snapshot:SS) {
    if (prevProps.costPriceData !== this.props.costPriceData) {
      this.chartPlace();
    }
  }
  chartPlace = () => {
    const { costPriceData } = this.props;
    if (costPriceData.length === 0) return [];

    const labels = Object.keys(costPriceData);
    const costData = labels.map(label => costPriceData[label].total_cost);
    const priceData = labels.map(label => costPriceData[label].total_price);
    return {
      labels,
      costData,
      priceData
    };
  };
  render() {

    const chartData = this.chartPlace();

    const option = costPriceChartOption(chartData);

    return (
       <ReactEcharts option={option}>
         opts={{ renderer: 'svg' }}
         style={{ height: '400px', width: '100%' }}
       </ReactEcharts>

    );
  }
}

const mapStateToProps = (state) => ({
  costPriceData: state.analyticalReducer.costPriceData
});

export default connect(mapStateToProps, {})(CostPriceDataChart);
